import { Component, OnInit, ViewChild } from '@angular/core';
import { SrubUpService } from '../Services/ScrubUp.service';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from '../Services/AppUserProfile';
 import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs';
 import {MatSort,Sort,MatTableModule,MatSortModule} from '@angular/material';
import {LiveAnnouncer} from '@angular/cdk/a11y';


interface USERROLE {
  RoleName:string;
  RoleCategory: string;
  IOSCount: string;
  AndroidCount:string
}
@Component({
  selector: 'app-surgeon-report',
  templateUrl: './surgeon-report.component.html',
  styleUrls: ['./surgeon-report.component.scss'],
  providers: [SrubUpService],
})
export class SurgeonReportComponent implements OnInit {
  public doughnutChartLabels:string[] =[];
  public doughnutChartData:number[] =[];
  //public doughnutChartLabels:string[] = ['test-new1', 'In-Store Sales', 'Mail-Order Sales','Download Sales', 'In-Store Sales', 'Mail-Order Sales','Download Sales', 'In-Store Sales', 'Mail-Order Sales','Download Sales', 'In-Store Sales', 'Mail-Order Sales','Download Sales', 'In-Store Sales', 'Mail-Order Sales','Download Sales', 'In-Store Sales', 'Mail-Order Sales','Download Sales', 'In-Store Sales', 'Mail-Order Sales','Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
  //public doughnutChartData:number[] = [350, 450, 100,350, 450, 100,350, 450, 100,350, 450, 100,350, 450, 100,350, 450, 100,350, 450, 100,350, 450, 100];
  public doughnutChartType:string = 'doughnut';
  displayedColumns: string[] = ['Name','SurgeonsAssigned'];
  dataSource1: eDataSource;
  ELEMENT_DATA: USERROLE[] =[];
  public loading = false;
  data:any=[];
   options: object;
  lineChartLegend=false;
  loginUserId: number;
  @ViewChild(MatSort)sort!: MatSort;
  constructor(private _liveAnnouncer: LiveAnnouncer, private scrubUpService: SrubUpService,private cookieService: CookieService, private appUser: AppWideUser, private token: Token) { 
    if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {

      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
            this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
            this.token = JSON.parse(this.cookieService.get('Token'));
        }
         this.loginUserId = this.appUser.UserId;
  }
  public chartClicked(e:any):void {
    //console.log(e);
  }

  public chartHovered(e:any):void {
    //console.log(e);
  }
  ngOnInit() {
    this.options= {
      hoverOffset: 10,
    layout:{
      padding:10
    }
      
    }
    this.getSurgonReport();
  }
  getSurgonReport() {
    this.loading = true;
    this.scrubUpService.GetSurgeonReport(this.token).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        this.data = x['Data'];
       // console.log(x['Data']);
        let name=[];
        let surgenassigned=[];
        for(var i=0;i<x['Data'].length;i++)
        {
         // console.log(x['Data'][i].SurgeonsAssigned);
          name.push(x['Data'][i].Name);
          surgenassigned.push(x['Data'][i].SurgeonsAssigned);
        }

        this.doughnutChartLabels = name;
        this.doughnutChartData = surgenassigned;
        this.dataSource1 = new eDataSource( x['Data']);
       // console.log(this.data);
      }
      this.loading = false;
     
    },
      error => {
        this.loading = false;
      })
  }
  announceSortChange(sortState: Sort) {
    //console.log(sortState.active);
   
    if (sortState.direction =='asc') {
     // this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
     
      this.data.sort((a, b) => a[sortState.active] > b[sortState.active] ? 1 : a[sortState.active] < b[sortState.active] ? -1 : 0);
      //console.log( this.data);
      return this.dataSource1 = new eDataSource(this.data);
    } else {
     // this._liveAnnouncer.announce('Sorting cleared');
      this.data.sort((a, b) => a[sortState.active] < b[sortState.active] ? 1 : a[sortState.active] > b[sortState.active] ? -1 : 0);
      //console.log( this.data);
      return this.dataSource1 = new eDataSource(this.data);
    }
  }
}
export class eDataSource extends DataSource<any> {

  constructor(private element: Element[]) {
    super();
  }

  connect(): Observable<Element[]> {
    return Observable.of(this.element);
  }

  disconnect() {}
  
}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/surgeon-report/surgeon-report.component.ts